{
    "list": [
        {
            "id": 1362670,
            "upPid": null,
            "policyNumber": null,
            "claimNumber": null,
            "mailSubj": "Ziadost klienta - Ina poziadavka \/ Ine",
            "mailBody": "Potrebujem dalsie spravu aby sme prkrocili stovnku",
            "mailFrom": "ekptest192@allianz.sk",
            "mailTo": "allianz@allianz.sk",
            "mailSend": "2024-04-24T15:17:03.355+02:00",
            "priorityId": 1,
            "dms2docId": "AK_PARTID198181",
            "dms2docBrandId": 3,
            "dms2docCatId": 4,
            "threadId": 1362670,
            "removedByUser": false,
            "unread": false,
            "visible": true,
            "typeLabel": "Komunik\u00e1cia cez Allianz Konto",
            "priorityLabel": "\u0161tandardn\u00e1",
            "dms2docCatLabel": "In\u00e9",
            "directionLabel": "AK Klient -\u003E Allianz",
            "dms2docBrandLabel": "NL - ostatn\u00e1 dokument\u00e1cia",
            "upItemId": null,
            "messageCount": 1,
            "unreadMessages": 0,
            "lastContactDate": "2024-04-24T15:17:03.355+02:00",
            "dms2Actnumber": null,
            "dms2Secflag": null
        },
        {
            "id": 1362671,
            "upPid": null,
            "policyNumber": null,
            "claimNumber": null,
            "mailSubj": "Ziadost klienta - Ina poziadavka \/ Ine",
            "mailBody": "Potrebujem dalsie spravu aby sme prkrocili stovnku",
            "mailFrom": "ekptest192@allianz.sk",
            "mailTo": "allianz@allianz.sk",
            "mailSend": "2024-04-24T15:17:51.574+02:00",
            "priorityId": 1,
            "dms2docId": "AK_PARTID198181",
            "dms2docBrandId": 3,
            "dms2docCatId": 4,
            "threadId": 1362671,
            "removedByUser": false,
            "unread": false,
            "visible": true,
            "typeLabel": "Komunik\u00e1cia cez Allianz Konto",
            "priorityLabel": "\u0161tandardn\u00e1",
            "dms2docCatLabel": "In\u00e9",
            "directionLabel": "AK Klient -\u003E Allianz",
            "dms2docBrandLabel": "NL - ostatn\u00e1 dokument\u00e1cia",
            "upItemId": null,
            "messageCount": 1,
            "unreadMessages": 0,
            "lastContactDate": "2024-04-24T15:17:51.574+02:00",
            "dms2Actnumber": null,
            "dms2Secflag": null
        },
        {
            "id": 1362672,
            "upPid": null,
            "policyNumber": null,
            "claimNumber": null,
            "mailSubj": "Ziadost klienta - Ina poziadavka \/ Ine",
            "mailBody": "Potrebujem dalsie spravu aby sme prkrocili stovnku",
            "mailFrom": "ekptest192@allianz.sk",
            "mailTo": "allianz@allianz.sk",
            "mailSend": "2024-04-24T15:18:57.798+02:00",
            "priorityId": 1,
            "dms2docId": "AK_PARTID198181",
            "dms2docBrandId": 3,
            "dms2docCatId": 4,
            "threadId": 1362672,
            "removedByUser": false,
            "unread": false,
            "visible": true,
            "typeLabel": "Komunik\u00e1cia cez Allianz Konto",
            "priorityLabel": "\u0161tandardn\u00e1",
            "dms2docCatLabel": "In\u00e9",
            "directionLabel": "AK Klient -\u003E Allianz",
            "dms2docBrandLabel": "NL - ostatn\u00e1 dokument\u00e1cia",
            "upItemId": null,
            "messageCount": 1,
            "unreadMessages": 0,
            "lastContactDate": "2024-04-24T15:18:57.798+02:00",
            "dms2Actnumber": null,
            "dms2Secflag": null
        },
        {
            "id": 1362673,
            "upPid": null,
            "policyNumber": null,
            "claimNumber": null,
            "mailSubj": "Ziadost klienta - Ina poziadavka \/ Ine",
            "mailBody": "Potrebujem dalsie spravu aby sme prkrocili stovnku",
            "mailFrom": "ekptest192@allianz.sk",
            "mailTo": "allianz@allianz.sk",
            "mailSend": "2024-04-24T15:19:00.639+02:00",
            "priorityId": 1,
            "dms2docId": "AK_PARTID198181",
            "dms2docBrandId": 3,
            "dms2docCatId": 4,
            "threadId": 1362673,
            "removedByUser": false,
            "unread": false,
            "visible": true,
            "typeLabel": "Komunik\u00e1cia cez Allianz Konto",
            "priorityLabel": "\u0161tandardn\u00e1",
            "dms2docCatLabel": "In\u00e9",
            "directionLabel": "AK Klient -\u003E Allianz",
            "dms2docBrandLabel": "NL - ostatn\u00e1 dokument\u00e1cia",
            "upItemId": null,
            "messageCount": 1,
            "unreadMessages": 0,
            "lastContactDate": "2024-04-24T15:19:00.639+02:00",
            "dms2Actnumber": null,
            "dms2Secflag": null
        },
        {
            "id": 1362674,
            "upPid": null,
            "policyNumber": null,
            "claimNumber": null,
            "mailSubj": "Ziadost klienta - Ina poziadavka \/ Ine",
            "mailBody": "Potrebujem dalsie spravu aby sme prkrocili stovnku",
            "mailFrom": "ekptest192@allianz.sk",
            "mailTo": "allianz@allianz.sk",
            "mailSend": "2024-04-24T15:19:04.287+02:00",
            "priorityId": 1,
            "dms2docId": "AK_PARTID198181",
            "dms2docBrandId": 3,
            "dms2docCatId": 4,
            "threadId": 1362674,
            "removedByUser": false,
            "unread": false,
            "visible": true,
            "typeLabel": "Komunik\u00e1cia cez Allianz Konto",
            "priorityLabel": "\u0161tandardn\u00e1",
            "dms2docCatLabel": "In\u00e9",
            "directionLabel": "AK Klient -\u003E Allianz",
            "dms2docBrandLabel": "NL - ostatn\u00e1 dokument\u00e1cia",
            "upItemId": null,
            "messageCount": 2,
            "unreadMessages": 0,
            "lastContactDate": "2024-05-15T08:40:02.538+02:00",
            "dms2Actnumber": null,
            "dms2Secflag": null
        },
        {
            "id": 1364799,
            "upPid": null,
            "policyNumber": null,
            "claimNumber": null,
            "mailSubj": "ekptest192@allianz.sk",
            "mailBody": "Test odpoved",
            "mailFrom": "ekptest192@allianz.sk",
            "mailTo": "allianz@allianz.sk",
            "mailSend": "2024-05-15T08:40:02.538+02:00",
            "priorityId": 1,
            "dms2docId": "AK_PARTID198181",
            "dms2docBrandId": 3,
            "dms2docCatId": 4,
            "threadId": 1362674,
            "removedByUser": false,
            "unread": false,
            "visible": true,
            "typeLabel": "Komunik\u00e1cia cez Allianz Konto",
            "priorityLabel": "\u0161tandardn\u00e1",
            "dms2docCatLabel": "In\u00e9",
            "directionLabel": "AK Klient -\u003E Allianz",
            "dms2docBrandLabel": "NL - ostatn\u00e1 dokument\u00e1cia",
            "upItemId": null,
            "messageCount": 2,
            "unreadMessages": 0,
            "lastContactDate": "2024-05-15T08:40:02.538+02:00",
            "dms2Actnumber": null,
            "dms2Secflag": null
        }
    ],
    "pagination": {
        "page": 0,
        "maxPage": 2,
        "maxItems": 6,
        "wsItemsPerPage": 100
    },
    "unreadMessagesCount": 2
}